// 🌐 جلب الرابط من REACT_APP_API_BASE_URL، وإذا لم يجده يستخدم الرابط الاحتياطي
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
};